module.exports = ".card-border{border-radius:.5rem;border:.09375rem solid #06f}.card-deck{margin-top:6rem!important;padding:0!important}.card{color:#06f}"